<template>
  <v-container fluid>
    <br>
    <h2 class="title-style">
      <v-icon class="icon-style">
        mdi-pencil
      </v-icon> Create User
    </h2>
    <v-card class="my-base-vcard-style">
      <br>
      <v-card
        class="my-vcard-style"
      >
        <v-container
          fluid
        >
          <v-card-text>
            <v-form
              ref="form"
              v-model="valid"
            >
              <v-row>
                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-text-field
                    v-model="firstName"
                    label="First Name*"
                    :rules="[(v) => !!v || 'This field is required']"
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-text-field
                    v-model="lastName"
                    label="Last Name*"
                    :rules="[(v) => !!v || 'This field is required']"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  sm="12"
                >
                  <address-form
                    ref="addressForm"
                    @addressEntered="assiginAddress($event)"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-text-field
                    v-model="phoneNumber"
                    label="Phone-Number"
                    type="number"
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-text-field
                    v-model="email"
                    label="Email*"
                    :rules="emailRules"
                    required
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  sm="12"
                >
                  <v-text-field
                    v-model="password"
                    label="Create your password"
                    min="8"
                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="showPassword ? 'text' : 'password'"
                    :rules="[(v) => !!v || 'Password is required']"
                    counter
                    required
                    @click:append="showPassword = !showPassword"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-autocomplete
                    v-model="role"
                    menu-props="auto"
                    :items="roleItems"
                    item-value="id"
                    item-text="name"
                    label="Role*"
                    :rules="[(v) => !!v || 'This field is required']"
                    single-line
                    hint="User Admin should be selected for Swift Check-In app."
                    persistent-hint
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-autocomplete
                    v-model="organizationId"
                    menu-props="auto"
                    :items="organizationList"
                    hint="By choosing an organization, It's Id will get fetched."
                    :rules="[(v) => !!v || 'Organization Id is required']"
                    item-value="external_id"
                    prepend-icon="mdi-domain"
                    item-text="name"
                    label="Select Organization*"
                  />
                </v-col>
              </v-row>
            </v-form>
            <br>
            <p class="text-sm-left">
              *indicates required field
            </p>
          </v-card-text>
          <v-card-actions>
            <v-btn
              color="red darken-3"
              @click="$router.push({ name: 'Users' })"
            >
              Back
            </v-btn>
            <v-spacer />
            <v-btn
              color="#FF3700"
              @click="submit()"
            >
              Create
            </v-btn>
          </v-card-actions>
        </v-container>
      </v-card>
      <br>
      <centre-spinner
        :loading="loading"
      />
    </v-card>
  </v-container>
</template>
<script>
  import Constants from 'src/constants';
  import spinner from 'src/views/dashboard/component/SpinnerCentre';
  import AddressForm from 'src/views/dashboard/component/AddressForm';

  export default {
    name: 'CreateUser',
    components: {
      'centre-spinner': spinner,
      'address-form': AddressForm,
    },
    data () {
      return {
        firstName: '',
        lastName: '',
        address: {},
        phoneNumber: null,
        role: '',
        organizationId: '',
        valid: false,
        showPassword: false,
        loading: false,
        password: '',
        email: '',
        emailRules: [
          (v) => !!v || 'E-mail is required',
          (v) => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid',
        ],
      };
    },
    computed: {
      organizationList () {
        return this.$store.getters['organizations/getOrganizationList'];
      },
      roleItems () {
        return this.$store.getters['accountcontrol/getRolesAndPermissionsList'];
      },

    },
    async mounted () {
      this.loading = true;
      await this.$store.dispatch('organizations/fetchOrganizationList');
      await this.$store.dispatch('accountcontrol/fetchRolesAndPermissionsList');
      this.loading = false;
    },
    methods: {
      submit () {
        this.$refs.addressForm.getEnteredAdress();
        if (this.$refs.form.validate() === false || Object.keys(this.address).length === 0) {
          this.$store.dispatch('alert/onAlert', {
            message: 'Please fill the required fields before proceeding.',
            type: Constants.ALERT_TYPE_ERROR,
          }, { root: true });
          return;
        }
        if (Object.keys(this.address).length > 0) {
          this.loading = true;
          this.$store.dispatch('users/createUser', {
            first_name: this.firstName,
            last_name: this.lastName,
            email: this.email,
            password: this.password,
            address: this.address,
            phone_number: this.phoneNumber,
            role_id: this.role,
            organization_id: this.organizationId,
          }).then(response => {
            this.$store.dispatch('alert/onAlert', {
              message: 'User created successfully.',
              type: Constants.ALERT_TYPE_SUCCESS,
            });
            this.address = {};
            this.loading = false;
            this.$router.push({ name: 'Users' });
          }).catch(() => {
            this.loading = false;
          });
        }
      },
      assiginAddress (address) {
        this.address = address;
      },
    },
  };
</script>
<style scoped>
.title-style {
  color: #37474F;
}
.icon-style {
  color: #37474F;
  font-size: 45px;
}
.my-vcard-style {
  margin-right: 30px;
  margin-left: 30px;
  background-color: #ECEFF1;
  border-radius: 25px;
}
.my-base-vcard-style {
  background-color: #CFD8DC !important;
}
</style>
